import { useCallback } from 'react';

import useLanguage from '../providers/Locale/hooks';
import I18nObject from '../types/I18nObject';
import { DEFAULT_LANGUAGE, LanguagesEnum } from '../types/languages';

const useI18nObjectTranslationName = () => {
	const { currentLanguage } = useLanguage();

	return useCallback(
		(i18n?: I18nObject, defaultValue?: string) => {
			if (!i18n) return defaultValue || '';

			if (!i18n[currentLanguage] && defaultValue) return defaultValue;

			const firstKey = Object.keys(i18n).find((key) => key);
			return [
				i18n[currentLanguage],
				i18n[DEFAULT_LANGUAGE],
				i18n[(firstKey ?? '') as LanguagesEnum],
			].find((name) => name)?.name;
		},
		[currentLanguage]
	);
};

export default useI18nObjectTranslationName;
